<body>
  <div *ngIf="!tokenLoaded">
    Please wait while you are authenticated.
  </div>
  <div *ngIf="tokenLoaded">
    <app-nav-menu></app-nav-menu>
    <router-outlet (activate)="updateAccessToken()"></router-outlet>
  </div>  
</body>
